module.exports = __webpack_public_path__ + "static/media/coments_icon.82f0e534.svg";